const getters = {
  multipleId(state) { // 获取用户信息
    return state.multipleId;
  }
};

export default getters;
